var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#A1A1A1",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.2.857a.857.857 0 0 0-1.714 0v.972h-.972A4.514 4.514 0 0 0 0 6.343v9.143A4.514 4.514 0 0 0 4.514 20h10.972A4.514 4.514 0 0 0 20 15.486V6.343a4.514 4.514 0 0 0-4.514-4.514h-.972V.857a.857.857 0 0 0-1.714 0v.972H7.2zm11.086 6.457v-.971a2.8 2.8 0 0 0-2.8-2.8h-.972v.971a.857.857 0 0 1-1.714 0v-.971H7.2v.971a.857.857 0 1 1-1.714 0v-.971h-.972a2.8 2.8 0 0 0-2.8 2.8v.971zM1.714 9.03h16.572v6.457a2.8 2.8 0 0 1-2.8 2.8H4.514a2.8 2.8 0 0 1-2.8-2.8z",
    clipRule: "evenodd"
  })));
};
export default SvgCalendar;